import { set, min } from 'lodash/fp';
import moment from 'moment';
import validate, { checkRequiredIntegerField, checkRequiredEditableField } from 'common/formValidation/lib';
import { validators as propertyValidators } from '../../common/property/PropertyForm';
import { validators as programValidators } from '../../common/property/ProgramForm';
import { GET } from '../../../../../utils/httpMethods';

let rentCeils = {};

const checkPropertyMonthlyRate = (
    errors,
    { propertyMonthlyRent, programZone, propertyWeightedSurface },
) => {
    GET('/api/settings/')
        .then((response) => response.json())
        .then((data) => {
            rentCeils = data.simulation.pinel.plafonds.zone;
        });
    const ceil = min([(0.7 + (propertyWeightedSurface ? 19 / propertyWeightedSurface : 0)).toFixed(2), 1.2])
        * rentCeils[programZone]
        * propertyWeightedSurface;

    if (ceil < propertyMonthlyRent) {
        return set(
            'propertyMonthlyRent',
            'Attention votre loyer dépasse le plafond au m² de la zone sélectionnée.',
            errors,
        );
    }

    return errors;
};

const checkDateActeRange = (errors, { propertyActDate }) => {
    const dateActe = moment(propertyActDate);
    const dateMin = moment('2026-03-01');
    const dateMax = moment('2028-12-31');

    if (dateActe.isBefore(dateMin, 'day')) {
        return set(
            'propertyActDate',
            'La date d\'acte ne peut pas être antérieure au 01/03/2026',
            errors,
        );
    }

    if (dateActe.isAfter(dateMax, 'day')) {
        return set(
            'propertyActDate',
            'La date d\'acte ne peut pas dépasser le 31/12/2028',
            errors,
        );
    }

    return errors;
};

const formValidate = validate([
    ...propertyValidators,
    ...programValidators,
    checkDateActeRange,
    checkRequiredIntegerField('propertyValue'),
    checkRequiredIntegerField('parkingLotValue'),
    checkRequiredIntegerField('propertyMonthlyRent'),
    checkPropertyMonthlyRate,
    checkRequiredEditableField('parkingEditableNotaryFees', 'parkingNotaryFees'),
    checkRequiredEditableField('parkingEditableOtherAcquisitionCost', 'parkingOtherAcquisitionCost'),
    checkRequiredEditableField('editableNotaryFees', 'notaryFees'),
    checkRequiredEditableField('editableOtherAcquisitionCost', 'otherAcquisitionCost'),
]);

export default formValidate;
